// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__21eyQ","actions":"GroupTable_actions__2cIPS","deleteModalFooter":"GroupTable_deleteModalFooter__2JXyC"};